import React from 'react';
import get from 'lodash/get';
import { Label } from '@grubhubprod/gh-cookbook-react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CorporateFormFields } from 'src/components/enterprise/features/Corporate/components/Form/types/CorporateForm';
import { CookbookRadioWrapper } from 'src/components/CookbookRadioWrapper/CookbookRadioWrapper';
import { useCorporateFormContext } from 'src/components/enterprise/features/Corporate/components/Form/CorporateFormProvider/useCorporateFormContext';

export enum BrandOptionsEnum {
  GRUBHUB = 'GRUBHUB',
  SEAMLESS = 'SEAMLESS',
}

export interface BrandOptionsProps {
  name: string;
  id: string;
}

export function BrandOptions({ name, id }: BrandOptionsProps): JSX.Element {
  const { control } = useFormContext();
  const { isEditPage, corpData } = useCorporateFormContext();

  return (
    <>
      <Label aria-label="Brand" inputSize="medium">
        Brand
      </Label>
      {isEditPage ? (
        get(corpData, name as keyof CorporateFormFields)
      ) : (
        <>
          <CookbookRadioWrapper
            name={name}
            id={`${id}${BrandOptionsEnum.GRUBHUB}`}
            control={control}
            label="Grubhub"
            value={BrandOptionsEnum.GRUBHUB}
          />
          <CookbookRadioWrapper
            name={name}
            id={`${id}${BrandOptionsEnum.SEAMLESS}`}
            control={control}
            label="Seamless"
            value={BrandOptionsEnum.SEAMLESS}
          />
        </>
      )}
    </>
  );
}
